<ng-container *ngIf="!isMobile; else mobileView">
  <ion-content scrollEvents="true" (ionScroll)="onScroll($event)">
    <!-- PAGE TITLE -->
    <div class="sb-sticky">
      <sb-simple-navbar [hasBackButton]="false" [fakeButton]="true">
        <h4 class="sb-back--title color-light">{{sport?.Name}}</h4>
      </sb-simple-navbar>
    </div>

    <!-- HIGHLIGHTS -->
    <ion-list *ngIf="(highlights$ | async).length > 1" class="desktop-list">
      <ion-list-header class="sport-countries-list--header background-color-regular">
        <ion-label>{{ 'cPDest'| translate }}</ion-label>
      </ion-list-header>
      <ion-grid>
        <ion-row>
          <ion-col size="12" size-md="6" size-lg="4" *ngFor="let league of highlights$ | async"
            ><ion-item class="highlights--list-item ion-item-title" (click)="navigate(league, true)" lines="none">
              <ion-label class="highlights--list-item-label">
                <ion-avatar item-left class="highlights--list-item-label-flag">
                  <img src="assets/global/img/banderas/ICO_{{ league?.CountryCode }}.png" />
                </ion-avatar>
                <p>{{ league.Name }}</p>
                <i item-right class="cs-arrow codere-icon icon-arrow-right"></i>
              </ion-label> </ion-item
          ></ion-col>
        </ion-row>
      </ion-grid>
    </ion-list>

    <ion-list class="desktop-list">
      <ion-list-header class="sport-countries-list--header background-color-regular">
        <ion-label>{{ groupTitle }}</ion-label>
      </ion-list-header>
      <ion-accordion-group
        [value]="selectedCountry"
        (ionChange)="selectedCountryChange($event)"
        class="sport-countries-list--accordion"
      >
        <ion-row>
          <ion-col
            size="12"
            size-lg="4"
            *ngFor="let country of countries$ | async; let index = index"
            [ngStyle]="{'z-index': 200 - index }"
          >
            <ion-accordion [value]="country?.NodeId" lines="none">
              <ion-item slot="header" color="light" class="accordion--item ion-item-title" lines="none" mode="ios">
                <ion-label class="accordion--item-label">
                  <p>{{ country.Name }}</p>
                  <ion-avatar item-left class="accordion--item-label-flag">
                    <img src="assets/global/img/banderas/ICO_{{ country?.CountryCode }}.png" />
                  </ion-avatar>
                </ion-label>
                <ion-icon
                  class="accordion--item-label-icon ion-accordion-toggle-icon"
                  name="chevron-forward-outline"
                  slot="start"
                ></ion-icon>
              </ion-item>
              <div class="ion-accordion--content" slot="content">
                <ion-list class="accordion--list">
                  <ion-item
                    *ngFor="let league of country?.Leagues"
                    class="accordion--list-item-content ion-item-title"
                    (click)="navigate(league, false, country)"
                  >
                    <ion-label class="accordion--list-item-content-label">
                      <p>{{ league.Name }}</p>
                      <i item-right class="cs-arrow codere-icon icon-arrow-right"></i>
                    </ion-label>
                  </ion-item>
                </ion-list>
              </div>
            </ion-accordion>
          </ion-col>
        </ion-row>
      </ion-accordion-group>
      <codere-footer [showFooterSpacer]="false"></codere-footer>
    </ion-list>
  </ion-content>
</ng-container>

<!-- mobile -->
<ng-template #mobileView>
  <ion-header>
    <sb-simple-navbar [hasBackButton]="true" [fakeButton]="true">
      <h4 class="sb-back--title color-light">{{ sport?.Name }}</h4>
    </sb-simple-navbar>
  </ion-header>
  <ion-content
    [ngClass]="{'no-scroll': globals?.iosScrollHide}"
    scrollEvents="true"
    (ionScroll)="onScroll($event)"
  >
    <div class="sb-sticky">
      <sb-tabs
        *ngIf="filters && filters?.length > 1"
        [categories]="filters"
        [color]="'regular'"
        [selectedTab]="currentFilter$ | async"
        (selectTab)=" selectedFilterChange($event)"
        selectedFilterChange
      ></sb-tabs>
    </div>

    <div [hidden]="(currentFilter$ | async)?.navigate !== 'highlight'" no-lines>
      <ion-list class="highlights--list">
        <ion-item
          *ngFor="let league of highlights$ | async"
          class="highlights--list-item ion-item-title"
          (click)="navigate(league, true)"
        >
          <ion-label class="highlights--list-item-label">
            <ion-avatar item-left class="highlights--list-item-label-flag">
              <img src="assets/global/img/banderas/ICO_{{ league?.CountryCode }}.png" />
            </ion-avatar>
            <p>{{ league?.Name }}</p>
            <i item-right class="cs-arrow codere-icon icon-arrow-right"></i>
          </ion-label>
        </ion-item>
      </ion-list>
    </div>
    <div [hidden]="(currentFilter$ | async)?.navigate !== 'az'" no-lines>
      <ion-accordion-group [value]="selectedCountry" (ionChange)="selectedCountryChange($event)">
        <ion-accordion
          *ngFor="let country of countries$ | async; let index = index"
          [value]="country?.NodeId"
          lines="none"
        >
          <ion-item slot="header" color="light" class="accordion--item ion-item-title" lines="none">
            <ion-label class="accordion--item-label">
              <p>{{ country?.Name }}</p>
              <ion-avatar item-left class="accordion--item-label-flag">
                <img src="assets/global/img/banderas/ICO_{{ country?.CountryCode }}.png" />
              </ion-avatar>
            </ion-label>
            <ion-icon
              class="accordion--item-label-icon ion-accordion-toggle-icon"
              name="chevron-forward-outline"
              slot="start"
            ></ion-icon>
          </ion-item>
          <div slot="content">
            <ion-list class="accordion--list">
              <ion-item
                *ngFor="let league of country?.Leagues"
                class="accordion--list-item-content ion-item-title"
                (click)="navigate(league, false, country)"
              >
                <ion-label class="accordion--list-item-content-label">
                  <p>{{ league.Name }}</p>
                  <i item-right class="cs-arrow codere-icon icon-arrow-right"></i>
                </ion-label>
              </ion-item>
            </ion-list>
          </div>
        </ion-accordion>
      </ion-accordion-group>
    </div>
    <codere-footer></codere-footer>
  </ion-content>
</ng-template>
